import { createRoot } from"react-dom/client";
import App from"./App.tsx";
import"./index.css";
import { registerServiceWorker } from"./lib/serviceWorker";
import { enforceChinaBlock, enforceChinaBlockByIp, enforceServerGeoBlock } from"./lib/chinaGate";

if (!enforceChinaBlock()) {
 createRoot(document.getElementById("root")!).render(<App />);
 registerServiceWorker();
 // Authoritative server-side IP check, then browser-side confirmation.
 void enforceServerGeoBlock().then((blocked) => {
 if (!blocked) void enforceChinaBlockByIp();
 });
}
